export default {
  whitelist : {
    insList : {
      title : '白名单',
      add:'添加白名单',
      all:'所有',
      noData:'没有数据，您可以',
      create:'创建一个白名单',
      searchName:'搜索IP/域名/联系人',
      searchButtonName:'搜索',
      ipAddress : 'IP地址',
      zone : '机房',
      goods : '所属产品',
      domain : '域名',
      openStatus : '开通状态',
      safeStatus : '审核状态',
      actions : '操作',
      actionsList:{
        'detail':'查看详情',
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/whitelist.js